import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Hook customizado para navegação com suporte a histórico
 * Fornece métodos de navegação inteligente que preservam o contexto
 */
export function useNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Volta para a página anterior no histórico
   * Se não houver histórico, vai para a rota de fallback
   */
  const goBack = useCallback((fallbackPath?: string) => {
    // Verifica se há histórico para voltar
    if (window.history.length > 1 && location.key !== 'default') {
      navigate(-1);
    } else if (fallbackPath) {
      navigate(fallbackPath);
    } else {
      navigate('/waba');
    }
  }, [navigate, location.key]);

  /**
   * Navega para uma rota mantendo o estado
   */
  const navigateWithState = useCallback((path: string, state?: any) => {
    navigate(path, { state });
  }, [navigate]);

  /**
   * Navega substituindo a entrada do histórico
   */
  const navigateReplace = useCallback((path: string, state?: any) => {
    navigate(path, { replace: true, state });
  }, [navigate]);

  return {
    navigate,
    goBack,
    navigateWithState,
    navigateReplace,
    location,
  };
}
